define('_collections/FanOf',[
	'_models/Fan'
],
function(
	FanModel
) {
	return Backbone.Collection.extend({
		url : function() {
			var path =  "/_api/v0/site/" + Backstage.Model.Default.get('site_url') + "/fanof";
			return path;
		},

		model: FanModel,

		comparator : "sort",

		fetch : function(options) {
			if ( $("script[data-set='Fanof']").html() ) {
				this.set( $.parseJSON( $("script[data-set='Fanof']").html() ), options );
			} else {
				Backbone.Model.prototype.fetch.apply(this, arguments);    
			}
		}
	});
});

